<div class="RegisterStepPay__wrapper">
  <div class="RegisterStepPay__wrapper__container">
    <h3>Payment</h3>
    <p class="text-center mt-3 font-weight-bolder">
      Complete the payment information to proceed to the next step.
    </p>
    <div
      class="RegisterStepPay__wrapper__container__form mt-5"
      [formGroup]="registerForm">
      <div class="row">
        <div class="col">
          <app-text-field
            placeholder="Name on card"
            formControlName="card_name"></app-text-field>
          <div
            *ngIf="
              (card_name.dirty && card_name.touched && card_name.invalid) ||
              (paymentErrors && paymentErrors.card_name)
            "
            class="alert alert-danger">
            <p
              class="mb-0"
              *ngIf="card_name.errors && card_name.errors.required">
              Card Holder name is required
            </p>
            <p class="mb-0" *ngIf="paymentErrors.card_name">
              Card Holder is invalid
            </p>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <app-text-field
            placeholder="Card Number...(16 caracters)"
            formControlName="card_number"></app-text-field>
          <div
            *ngIf="
              (card_number.dirty &&
                card_number.touched &&
                card_number.invalid) ||
              (paymentErrors && paymentErrors.card_number)
            "
            class="alert alert-danger">
            <p
              class="mb-0"
              *ngIf="card_number.errors && card_number.errors.required">
              Card Holder name is required
            </p>
            <p class="mb-0" *ngIf="paymentErrors.card_number">
              Card Holder is invalid
            </p>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col col-md-6">
          <app-select
            [items]="months"
            label="Expire Month (MM)"
            [defaultValue]="currentMonth"
            formControlName="expire_month"></app-select>
        </div>
        <div class="col col-md-6">
          <app-select
            [items]="years"
            label="Expire Year (YY)"
            [defaultValue]="currentYear"
            formControlName="expire_year"></app-select>
        </div>
      </div>
      <div *ngIf="paymentErrors && paymentErrors.exp_period" class="row mt-3">
        <div class="alert alert-danger">
          <p class="mb-0">Card Expiration Date is invalid</p>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <app-text-field
            placeholder="CVV Code (3 caracters found behind the card)"
            formControlName="card_id"></app-text-field>
          <div
            *ngIf="
              (card_id.dirty && card_id.touched && card_id.invalid) ||
              (paymentErrors && paymentErrors.card_id)
            ">
            <div class="alert alert-danger">
              <p class="mb-0" *ngIf="card_id.errors && card_id.errors.required">
                Card Security Code name is required
              </p>
              <p class="mb-0" *ngIf="card_id.errors && card_id.errors.pattern">
                Card Security Code should contains only digits
              </p>
              <p
                class="mb-0"
                *ngIf="
                  card_id.errors &&
                  (card_id.errors.minlength || card_id.errors.maxlength)
                ">
                Card Security Code should be 3 digits
              </p>
              <p class="mb-0" *ngIf="paymentErrors && paymentErrors.card_id">
                Card Security Code is invalid
              </p>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="currentValidTeamCode" class="row mt-3">
        <div class="col col-md-6">
          <label class="d-block mb-0">One Time Charge:</label>
          <input
            type="text"
            readonly
            formControlName="amount"
            class="float-left" />
        </div>
        <div class="col col-md-6">
          <label class="d-block mb-0">Recurring Plan Charge:</label>
          <app-text-field
            placeholder="Recurring Plan Charge"
            formControlName="plan_amount"
            [disabled]="true"></app-text-field>
        </div>
      </div>
      <div *ngIf="!currentValidTeamCode" class="row mt-3">
        <div class="col">
          <label class="d-block mb-0">Monthly Charge:</label>
          <app-text-field
            placeholder="Montly Charge"
            [disabled]="true"
            formControlName="amount"></app-text-field>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <app-button
            [text]="'next'"
            [Click]="submitForm"
            [color]="'orange'"
            [size]="'normal'"
            [style]="'rounded'"></app-button>
        </div>
      </div>
    </div>
  </div>
</div>
